import {defineStore} from 'pinia';
import {computed, ref} from 'vue';
import {useApiClient} from "@/hooks/api-hook.ts";
import {AuditLog} from "@/api/client/models/index.ts";

export const useCharterAuditLogsStore = defineStore('charter-audit-logs', () => {
  const api = useApiClient();

  // State
  const auditLogs = ref<AuditLog[]>([]);
  const loading = ref(false);
  const error = ref<string | null>(null);

  // Getters
  const auditLogsCount = computed(() => auditLogs.value.length);
  const hasAuditLogs = computed(() => auditLogs.value.length > 0);
  const isLoading = computed(() => loading.value);
  const hasError = computed(() => error.value !== null);

  // Actions
  async function fetchAuditLogs() {
    loading.value = true;
    error.value = null;

    try {
      auditLogs.value = await api.charterAuditLog.get()
    } catch (err) {
      error.value = err instanceof Error ? err.message : 'Failed to fetch audit logs';
      console.error('Error fetching audit logs:', err);
    } finally {
      loading.value = false;
    }
  }

  function clearAuditLogs() {
    auditLogs.value = [];
    error.value = null;
  }

  function clearError() {
    error.value = null;
  }

  return {
    // State
    auditLogs,
    loading,
    error,

    // Getters
    auditLogsCount,
    hasAuditLogs,
    isLoading,
    hasError,

    // Actions
    fetchAuditLogs,
    clearAuditLogs,
    clearError
  };
});
